module.exports = __webpack_public_path__ + "static/img/chuzhongshuxue3.a4ffa366.jpg";